import { ListData } from '@fi-app/components/items-list/list-data.service';
import { Injector } from '@angular/core';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { ObjectTypes } from '@fi-shared/types';
import { IFormReportQuestionAnswerColleague } from '../../../fi-form-report';
import { UserListProfileIconColumnComponent } from '@fi-app/user/user-list/user-list-profile-icon-column/user-list-profile-icon-column.component';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class FormReportQuestionDetailsAnswerListData extends ListData<IFormReportQuestionAnswerColleague> {
    constructor(
        injector: Injector,
        reportItemClickCallback: (item: IFormReportQuestionAnswerColleague, parentData) => void,
    ) {
        super(injector, true);

        this.MultiSelect = false;
        this.ShowDelete = false;
        this.ShowCheckAll = false;
        this.ShowCheckBox = false;
        this.CanShowLoadMore = false;
        this.ObjectType = ObjectTypes.Form;
        this.ChildProperty = 'AnswerSets';

        this.Header.push(
            new ItemsListHeader(
                '',
                '',
                new ItemsListHeaderProperties(
                    'CcmListItem-Icon CcmListItem-NoBorder',
                    true,
                    UserListProfileIconColumnComponent,
                ),
                undefined,
                undefined,
                (data, propertyName, parentData) => (parentData ? parentData : data),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('colleague'),
                'FullName',
                new ItemsListHeaderProperties('CcmListItem-Name CcmListItem-NoBorder', true, ItemsListElementType.A, {
                    onClick: ($event, data: IFormReportQuestionAnswerColleague, parentData) => {
                        $event.stopPropagation();
                        // we should expand only if click on colleague and this colleague has only 1 answer set
                        if (!parentData && data.AnswerSets.length !== 1) {
                            this.toggleChildrenItems(data);
                        } else {
                            reportItemClickCallback(data, parentData);
                        }
                    },
                }),
                undefined,
                undefined,
                (data, prop, parentData) => {
                    if (parentData) return parentData.FullName;
                    if (data.AnswerSets.length > 1) return `${data.FullName} (${data.AnswerSets.length})`;
                    return data.FullName;
                },
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('form.question_answer_date'),
                '',
                new ItemsListHeaderProperties(
                    'CcmListItem-NoBorder CcmList-Column-ShowAlways',
                    true,
                    ItemsListElementType.SpanPlain,
                    { isRightAligned: true },
                ),
                null,
                null,
                (data, prop, parentData) => {
                    if (parentData) {
                        return injector.get(FiFormatDateService).formatDate(data.CreatedOn, 'date');
                    }
                    if (data.AnswerSets.length === 1) {
                        return injector.get(FiFormatDateService).formatDate(data.AnswerSets[0].CreatedOn, 'date');
                    }
                    return '';
                },
            ),
        );
    }

    getRowClass(data: IFormReportQuestionAnswerColleague) {
        if (data && data.AnswerSets && data.AnswerSets.length === 1) return 'hide-collapse-icon';
    }
}
